import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import MenubarMenuItemInput from "../../../components/Menubar/MenubarMenuItemInput";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import {
  getMenubarSubmenuById,
  getMenubarDataById,
} from "../../../utils/ApiCalls/Menubar";

const EditMenubarMenuItem = () => {
  const params = useParams();
  const menubarId = params?.menubarId;
  const [submenu, setSubmenu] = useState({});
  const [menubar, setMenubar] = useState({});
  const [, dispatch] = useDataLayerValue();

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Menubar", route: "/website/cms/homepage/menubar" },
    { title: "Sub-menu", route: `/website/cms/homepage/menubar/${menubarId}/view` },
    {
      title: "Edit Sub-menu",
      route: `/website/cms/homepage/menubar/${menubarId}/view/edit/${params?.id}`,
    },
  ];

  useEffect(() => {
    getData(params?.id);
    getParentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    let data = await getMenubarSubmenuById(menubarId, id);
    if (data?.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else {
      setSubmenu(data);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  const getParentData = async () => {
    let data = await getMenubarDataById(menubarId);
    if (!data?.error) setMenubar(data);
  };

  return (
    <Layout type={"update_per"} module_data={"Menubar"}>
      <HeaderBread navigation={navigation} title={"Edit Sub-menu"}></HeaderBread>
      {submenu && (
        <MenubarMenuItemInput
          menubarId={menubarId}
          parentUrl={menubar?.url}
          submenu={submenu}
        />
      )}
    </Layout>
  );
};

export default EditMenubarMenuItem;
